import styled from "styled-components";

export default styled.section`
  margin-top: 20px;
  .clearance--status {
    display: flex;
    color: rgba(0, 0, 0, 0.87);
    font-size: 11px;
    margin-bottom: 5px;
    .use-icon {
      background: #8bc34a;
      color: #fff;
      border-radius: 50%;
      margin-right: 15px;
      font-size: 12px;
      user-select: none;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      -o-user-select: none;

      width: 14px;
      height: 14px;
      display: inline-block;
      text-align: center;
      line-height: 17px;
      font-size: 11px;

      &.yellow {
        background: #ea8329;
      }

      &.red {
        background: #e14336;
      }
    }

    .dot {
      flex: 0 0 auto;
    }
    .message {
      flex: 1 1 auto;
    }
    .clearance-message {
      font-size: 12px;
      line-height: 12px;
      padding-left: 28px;
      font-style: italic;
    }
  }

  @media screen and (max-width: 991px) {
    min-height: auto;
  }
`;
